import * as React from 'react';

import * as styles from './boxSection.module.scss';

export interface BoxSectionProps {
  children: React.ReactNode;
  theme: 'beige' | 'white';
}

const BoxSection = ({children, theme}: BoxSectionProps) => {
  const randomInt = Math.floor(Math.random() * (10 - 1 + 1)) + 1;
  const style: React.CSSProperties = {
    // stylelint-disable
    backgroundPosition: `center ${randomInt * 10}%`,
  };
  return (
    <div className={`${styles.wrapper} ${styles[theme]}`}>
      <hr style={style} className={styles.bar} />
      {children}
    </div>
  );
};

export default BoxSection;
